import { StyleSheet } from 'react-native';
import { neutrals, shadows } from 'src/theme/colors';

export const styles = StyleSheet.create({
  legerPreviewContainer: {
    pointerEvents: 'none',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  legerPreviewShadow: {
    width: '80%',
    height: '80%',
    shadowColor: shadows.shadowOne,
    shadowOffset: {
      width: 0,
      height: 50,
    },
    shadowOpacity: 0.65,
    shadowRadius: 80.0,

    elevation: 25,
  },
  legerPreviewWhite: {
    backgroundColor: neutrals.white,
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
});
